import { createContext, useState, ReactNode, FC, useContext } from "react";

interface CurrentAppContextProps {
  currentApp: string | undefined;
  setCurrentApp: (app: string | undefined) => void;
}

const CurrentAppContext = createContext<CurrentAppContextProps | undefined>(
  undefined
);

interface CurrentAppProviderProps {
  children: ReactNode;
}

export const CurrentAppProvider: FC<CurrentAppProviderProps> = ({
  children,
}) => {
  const [currentApp, setCurrentApp] = useState<string | undefined>(undefined);

  return (
    <CurrentAppContext.Provider value={{ currentApp, setCurrentApp }}>
      {children}
    </CurrentAppContext.Provider>
  );
};

export const useCurrentApp = () => {
  const context = useContext(CurrentAppContext);
  if (!context) {
    throw new Error("useCurrentApp must be used within a CurrentAppProvider");
  }
  return context;
};
